// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1bec6fb8","453":"7cbd65b3","455":"4a8e4d80","977":"e8bd13c1"}[chunkId] + ".chunk.js";
};